import { SupportedLanguage, LanguageCode } from '../types/i18n.types';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  {
    code: 'vi',
    name: 'Vietnamese',
    nativeName: 'Tiếng Việt',
    flag: '🇻🇳',
    dir: 'ltr'
  },
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸',
    dir: 'ltr'
  }
];

export const DEFAULT_LANGUAGE: LanguageCode = 'vi';

export const FALLBACK_LANGUAGE: LanguageCode = 'en';

export const SUPPORTED_NAMESPACES = [
  'common',
  'header',
  'chat',
  'admin',
  'settings',
  'errors',
  'auth',
  'models'
] as const;

export const LANGUAGE_STORAGE_KEY = 'sme-language';

export const getLanguageByCode = (code: string): SupportedLanguage | undefined => {
  return SUPPORTED_LANGUAGES.find(lang => lang.code === code);
};

export const isValidLanguageCode = (code: string): code is LanguageCode => {
  return SUPPORTED_LANGUAGES.some(lang => lang.code === code);
};